import { CSVLink } from 'react-csv'
import { Button } from 'reactstrap'

const ExportVisit = ({ datasets, isDisabled = false, style, visitPerson }) => {
  const headers = [
    { label: 'Township', key: 'township.short_code' },
    { label: 'Visit Count', key: 'total' },
  ]


  const addFooterName = {
    township: { short_code: 'Name' },
    total: visitPerson,
  }

  const exportedData = [...datasets,addFooterName]

  return (
    <CSVLink
      filename={`Visit Person - ${visitPerson}.csv`}
      data={exportedData}
      headers={headers}
    >
      <Button
        disabled={isDisabled}
        style={{ ...style }}
        color="warning"
        type="button"
      >
        Export
      </Button>
    </CSVLink>
  )
}
export default ExportVisit
